const state = {
    data: []
}

const mutations = {
    add(state, data) {
        let foundIndex = state.data.findIndex(k => k.id === data.id);
        if (foundIndex < 0) {
            state.data.push(data);
        } else {
            let newArray = state.data
            newArray[foundIndex] = data

            state.data = newArray
        }
    },
    save(state, data) {
        state.data = data
    },
}

export default {
    namespaced: true,
    state,
    mutations,
}



// WEBPACK FOOTER //
// ./src/store/bahan-baku.js